const DINES_LOGO_PATHS = [
  "M16.9081831 10.4113664L16.8980766 13.3572513 16.8966532 13.358503C16.8939486 14.1613446 16.4336064 14.8576598 15.7584662 15.2135358 15.7194638 15.2331444 15.6804614 15.252753 15.6400356 15.270971L9.85956599 18.04608 15.424953 15.3673454 9.64448338 18.1424544C9.60405753 18.1606724 9.56505513 18.1801419 9.52605272 18.1997506 8.85077021 18.5556265 8.3905703 19.2519417 8.38772341 20.0547834L8.36210139 27.5123239",
  "M8.5632627 1.45939723L8.53493613 9.67249619 8.53365503 9.67249619C8.53080814 10.4751987 8.07060823 11.1716531 7.39532572 11.527529 7.35632331 11.5469986 7.31732091 11.5666072 7.2770374 11.5848251L1.49656783 14.3599342 7.06181245 11.6825902 1.28134288 14.4576992C1.24105937 14.4759172 1.20205697 14.4953868 1.16305456 14.5149954.487772048 14.8708713.0274297936 15.5671866.0247252472 16.3700282L-.0000427033631 23.5520744",
  "M10.5852242,28.7972738 C10.5354036,28.8246703 10.484302,28.8494245 10.4319192,28.868894 C10.2544155,28.9417658 10.0582647,28.9818175 9.85414266,28.9811222 C9.02712086,28.9784799 8.35938261,28.3202694 8.36208715,27.5122822",
  "M16.0103876,26.2649642 C16.0103876,26.2662158 16.0091065,26.2662158 16.0091065,26.2662158 L15.8879713,26.3222604 C15.8866902,26.3236511 15.8839856,26.323512 15.8825622,26.3249027 L10.4319049,28.8688801",
  "M15.8866332 23.6003033L15.9764527 23.6399378C16.5126645 23.9040286 16.8584194 24.4679507 16.8039015 25.0895863 16.7577819 25.6062252 16.4449085 26.0381716 16.0090496 26.2662437 15.9686237 26.2884946 15.9256357 26.3079642 15.8826476 26.3249305M10.6370377.101937105C10.6410233.103327788 10.6464324.105970087 10.650418.107221702L15.7342534 2.34872546",
  "M12.193 21.973L15.887 23.6 15.977 23.64",
  "M8.56283566 1.45898003C8.56568255.65099288 9.23783349-.00276746028 10.0649976.0000139068356 10.2691197.000570180259 10.4733841.0338075173 10.6503184.107791883M16.9081831 10.4113664L16.9232716 4.87255189 16.9265455 4.29931213C16.927969 4.25606187 16.9268302 4.21281161 16.9269726 4.17081297 16.9013506 3.42165173 16.4687655 2.70795293 15.7342676 2.34873937M0 23.552422C.0323122114 24.3542902.519699929 25.0335 1.20779345 25.365039 1.2469382 25.3821444 1.28693702 25.4010577 1.32793225 25.4176068L1.86385945 25.6508245 4.62591298 26.8529313 1.86599462 25.6460961",
];

const LOGO_GROUP_PROPS = {
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  strokeWidth: 2.156,
};

const LogoSvg = ({ stroke }: { stroke: string }) => (
  <svg
    className="h-24 w-24"
    viewBox="-1 -1 20 32"
    fill="none"
    aria-hidden="true"
  >
    <g {...LOGO_GROUP_PROPS} stroke={stroke}>
      {DINES_LOGO_PATHS.map((d) => (
        <path key={d.slice(0, 20)} d={d} />
      ))}
    </g>
  </svg>
);

const DinesLogoFill = () => (
  <>
    <style>
      {`@keyframes dines-fill-wave {
        0%, 100% { clip-path: inset(100% 0 0 0); }
        50% { clip-path: inset(0% 0 0 0); }
      }`}
    </style>
    <div className="relative">
      <LogoSvg stroke="#e5e7eb" />
      <div
        className="absolute inset-0"
        style={{ animation: "dines-fill-wave 4s ease-in-out infinite" }}
      >
        <LogoSvg stroke="#5ff2ac" />
      </div>
    </div>
  </>
);

export default DinesLogoFill;
